import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieSettingsButtonComponent, CookieSettingsService } from '@capital-access/common/components';
import { Breakpoint } from '@capital-access/firefly/components';
@Component({
  selector: 'ca-footer',
  template: `
    <div class="d-flex align-items-center justify-content-between px-3" [class.mobile-style-footer]="isMobile">
      <span class="text-muted small">© {{ currentYear }} S&P Global. All Rights Reserved</span>
      @if (shouldShowCookieBanner$ | async) {
      <ca-cookie-settings-button></ca-cookie-settings-button>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        padding: 0.5rem 0;
        border-top: 1px solid var(--bs-border-color);
        margin-top: auto;
      }
      .mobile-style-footer {
        flex-direction: column-reverse;
        align-items: start !important;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, AsyncPipe, CookieSettingsButtonComponent]
})
export class FooterComponent {
  shouldShowCookieBanner$: Observable<boolean>;

  constructor(private cookieSettingsService: CookieSettingsService) {
    this.shouldShowCookieBanner$ = this.cookieSettingsService.shouldShowCookieBanner();
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }

  get isMobile(): boolean {
    return window.innerWidth < Breakpoint.Sm;
  }
}
